module.exports = __webpack_public_path__ + "img/enjoylife.4f314b1b.png";